import Base from '../base';

class Reference extends Base {
	getReferenceList(type) {
		const api = this._api
			.url(`/ref/${type}`)
			.GET;
		return this.request(api);
	}

	createReference({ type, ref }) {
		const api = this._api
			.url(`/ref/${type}`)
			.data({ ...ref })
			.POST;
		return this.request(api);
	}

	editReference({ type, ref }) {
		const api = this._api
			.url(`/ref/${type}/${ref.id}`)
			.data({ ...ref })
			.PUT;
		return this.request(api);
	}

	deleteReference({ type, id }) {
		const api = this._api
			.url(`/ref/${type}/${id}`)
			.DELETE;
		return this.request(api);
	}
}

export default new Reference();
